window.bundleConfig = {
"samsung-entry-range-pack-1": {
type: "percentage",
        discount: 10,

        products: [

            "samsung-ceramic-cooktop-4-zone-60cm",

            "samsung-bespoke-power-ventilation-rangehood-90cm",

            "samsung-4-series-oven-catalytic-12-function-76l",

            "samsung-barosa-427l-fridge-freezer",

            "samsung-freestanding-dishwasher-flexible-3rd-rack-14-place-setting-silver"

        ]

    },

    "samsung-mid-range-pack-1": {
type: "percentage",
        discount: 10,

        products: [

            "samsung-induction-cooktop-flex-zone-plus-60cm",

            "samsung-bespoke-power-ventilation-rangehood-90cm",

            "samsung-bespoke-6-series-oven-dual-cook-steam-22-function-76l",

            "samsung-srf7500bb-648l-french-door-fridge-freezer",

            "samsung-freestanding-dishwasher-flexible-3rd-rack-14-place-setting-black-stainless"

        ]

    },

    "samsung-premium-range-pack-1": {
type: "percentage",
        discount: 10,

        products: [

            "samsung-induction-cooktop-flex-zone-plus-80cm",

            "samsung-bespoke-power-ventilation-rangehood-90cm",

            "samsung-bespoke-ai-6-series-oven-dual-cook-flex-steam-23-function-76l",

            "samsung-freestanding-dishwasher-flexible-3rd-rack-14-place-setting-black-stainless",

            "samsung-4-door-french-door-refrigerator-family-hub-636l"

        ]

    },

 "samsung-large-11kg-washing-machine-and-dryer-deal": {

        type: "fixed",
        salePrice: 2896,

        products: [
            "samsung-front-load-washer-11kg",
            "samsung-heat-pump-dryer-ai-dry-9kg-white"
        ]

    },

  

    "samsung-auto-dose-washing-machine-and-dryer-deal": {

        type: "fixed",
        salePrice: 2496,

        products: [
            "samsung-front-load-washer-auto-dose-9kg",
            "samsung-heat-pump-dryer-ai-dry-9kg-white"
        ]

    },


    "bosch-series-4-washing-machine-and-dryer-deal": {

        type: "fixed",
        salePrice: 2698,

        products: [
            "bosch-series-4-8kg-washing-machine",
            "bosch-series-4-8kg-heat-pump-dryer"
        ]

    },


    "bosch-series-6-washing-machine-and-dryer-deal": {

        type: "fixed",
        salePrice: 3198,

        products: [
            "bosch-series-6-9kg-washing-machine-with-i-dos",
            "wqg24200au-bosch-series-6-heat-pump-tumble-dryer-9kg"
        ]

    },


    "bosch-series-8-washing-machine-and-dryer-deal": {

        type: "fixed",
        salePrice: 3998,

        products: [
            "bosch-series-8-9kg-washing-machine",
            "wqg235d8au-bosch-series-8-heat-pump-tumble-dryer-8kg"
        ]

    },


    "smeg-freestanding-oven-and-powerpack-deal": {

        type: "fixed",
        salePrice: 4297,

        products: [
            "smeg-classic-90cm-freestanding-oven-with-gas-cooktop-stainless-steel",
            "smeg-90cm-stainless-steel-powerpack"
        ]

    },


    "smeg-pyrolytic-oven-and-induction-cooktop-deal": {

        type: "fixed",
        salePrice: 3196,

        products: [
            "smeg-classic-60cm-oven-with-pyrolytic-cleaning",
            "smeg-classic-4-zone-induction-60cm-cooktop-black"
        ]

    },


    "bosch-pyrolytic-oven-and-induction-cooktop-deal": {

        type: "fixed",
        salePrice: 3198,

        products: [
            "bosch-series-4-built-in-oven-hba574eb3a-60cm-black",
            "puj611bb5h-bosch-series-4-induction-cooktop-60cm-surface-mount-without-frame"
        ]

    },


    "samsung-pyrolytic-oven-and-induction-cooktop-deal": {

        type: "fixed",
        salePrice: 2999,

        products: [
            "samsung-4-series-oven-dual-cook-pyrolytic-14-function-76l",
            "samsung-induction-cooktop-flex-zone-plus-60cm"
        ]

    }

};